import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f5d7990"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dv-question-title" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = {
  key: 0,
  class: "dv-title-index"
}
const _hoisted_4 = {
  key: 1,
  class: "dv-title-score"
}
const _hoisted_5 = { class: "wheel_card_body" }
const _hoisted_6 = {
  key: 0,
  class: "sucAnswer"
}
const _hoisted_7 = { class: "correct_answer-title" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 正确答案： ")
const _hoisted_9 = {
  key: 0,
  class: "m-question-analysis"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-analysis-title" }, "解析:", -1))
const _hoisted_11 = ["innerHTML"]

import _ from "lodash";
import { onMounted, reactive, ref } from "vue";
import useColorWheel from "@/hooks/useColorWheel";
import ColorWheelPiece from "./ColorWheelPiece.vue";
import { unLock } from "@/utils/liner-lock";
import useCompileContent from "@/hooks/useCompileContent";
import ColorWheelAnswer from "./ColorWheelAnswer.vue";
import { getScaleRate } from "@/utils/rem";


export default /*#__PURE__*/_defineComponent({
  props: {
  question: {
    type: Object,
  },
  disabled: {
    type: Boolean,
  },
  showQuestionNum: {
    type: Boolean,
    default: true,
  },
  showQuestionScore: {
    type: Boolean,
    default: true,
  },
},
  setup(__props, { expose }) {

const props = __props



const { createWheelCard } = useColorWheel();
const { compileQuestionTitle } = useCompileContent();
const scale = getScaleRate();

// 色环部分的数据
const wheelInfo = ref<any[]>([]);

// 待选项
const checkInfo = ref<any[]>([]);

// 色环elmenmt对象
const wheelCardRef = ref();

const optRef = ref();

const wheelCardChart = ref<any>();

const questionInfo = ref<any>(props.question);

const standardAnswer = ref([]);

const startItem = ref();

const wheelRadius = 250 * scale;

// * 标题编译
const questionTitle = ref<HTMLDivElement>();
compileQuestionTitle(questionTitle, questionInfo.value.title || "");

const dropItem = reactive({
  show: false,
  info: {
    serial: 0,
    color: null,
    old_serial: 0,
  },
  from: "opt",
  style: { left: "0px", top: "0px" },
});

/** 渲染及初始化数据处理部分 */

// 将对数据进行挖槽
const initWheelData = (
  wheelList: any[],
  checkList: any[],
  answerInfo: any[]
) => {
  wheelList.forEach((item: any) => {
    if (_.find(checkList, (i) => i.serial === item.serial)) {
      item.color = null;
      item.choose = true;
    }
  });

  const newCheck = checkList.filter(
    (item) => answerInfo.find((i) => i.color === item.color) === undefined
  );
  // 根据start_item 进行旋转
  const list = _.cloneDeep(wheelList || []);
  const startItem = questionInfo.value?.question_params.start_item;

  let i = 1;
  while (i < startItem) {
    const tmp = list.shift();
    list.push(tmp);
    i++;
  }

  list.forEach((item) => {
    const ans = answerInfo.find((i) => i.box_serial === item.serial);
    if (ans) {
      item.color = ans.color;
      item.old_serial = ans.item_serial;
    }
  });

  wheelInfo.value = list;
  checkInfo.value = newCheck;
};

// 渲染色环
const renderWheelCard = () => {
  const chart = createWheelCard({
    elmRef: wheelCardRef.value,
    list: _.cloneDeep(wheelInfo.value),
    createConfig: {},
  });
  wheelCardChart.value = chart;

  chart.render();
  chart.getElements().forEach((elm) => {
    elm.setState("selected", true);
  });
};

// 初始化题目信息
const initQuestion = () => {
  questionInfo.value = props.question;
  const wheelInfoList = _.cloneDeep(
    props.question?.question_params.raw_items || []
  );
  const checkInfoList = _.cloneDeep(
    props.question?.question_params.check_items || []
  );
  const answerInfo = props.question?.answer_params?.items || [];
  startItem.value = props.question?.question_params.start_item || 1;
  standardAnswer.value = _.cloneDeep(props.question?.question_params.raw_items);
  initWheelData(wheelInfoList, checkInfoList, answerInfo);
  renderWheelCard();
};

// 更新拖拽中的节点的位置;
const updateMousePosition = _.throttle((e: any) => {
  dropItem.style = { left: `${e.clientX - 50}px`, top: `${e.clientY - 20}px` };
}, 10);

// 更新色环信息
const updateWheelInfo = (info: any) => {
  wheelInfo.value.forEach((item) => {
    if (item.serial === info.serial) {
      item.color = info.color;
      item.old_serial = info.old_serial;
    }
  });
  const newList = wheelInfo.value.map((i) => ({
    ...i,
    value: 1,
  }));
  wheelCardChart.value.changeData(newList);
};

// 隐藏移动的色块
const hiddenDropItem = () => {
  dropItem.info = { serial: 0, color: null, old_serial: 0 };
  dropItem.show = false;
};

/** 数据处理部分 */

// 根据坐标获取对应的色环上的块信息
const getInfoByPosition = (x: number, y: number, list: any[]) => {
  const len = x * x + y * y;
  if (
    len > 0.95 * 0.95 * wheelRadius * wheelRadius ||
    len < 0.6 * 0.6 * wheelRadius * wheelRadius
  ) {
    return null;
  }

  const tan = x / y;
  // 用角度制是为了过滤掉边界精度丢失的情况
  const step = 360 / list.length;
  const r = Math.PI / 180;
  let index = 0;
  while (index < list.length) {
    let start = step * index;
    let end = step * (index + 1);
    if (end === 90) {
      end -= 1;
    }
    if (start === 90) {
      start += 1;
    }
    const tanList = [Math.tan(start * r), Math.tan(end * r)];
    if (
      tan <= Math.max(tanList[0], tanList[1]) &&
      tan > Math.min(tanList[0], tanList[1])
    ) {
      // 第三象限
      if (x < 0 && y < 0) {
        index = index + 6;
      }
      // 第四象限
      if (x < 0 && y > 0) {
        index = index + 6;
      }
      return list[index];
    }
    index++;
  }
  return null;
};

// 保存当前移动的色块的信息
const saveDragPieceInfo = (e: any, info: any, from = "opt", show = false) => {
  // 拖拽色块开始
  dropItem.info = info;
  dropItem.style = { left: `${e.clientX - 50}px`, top: `${e.clientY - 5}px` };
  dropItem.from = from;
  dropItem.show = show;
};

// 拖拽到色环中
const handleWheelDrop = (e: any) => {
  // 先计算出圆环的相对屏幕的偏移量，然后x值减去偏移量，得到相对于圆环对象的x值
  const left = wheelCardRef.value.getBoundingClientRect().left;
  const top = wheelCardRef.value.getBoundingClientRect().top;

  // 鼠标位置相对于圆心的坐标
  const x = e.clientX - left - wheelRadius;
  const y = wheelRadius - e.clientY + top;
  console.log(11, wheelCardRef.value, x, y);
  if (y === 0 || x === 0) {
    hiddenDropItem();
    return;
  }

  // 对应的节点的信息
  const dropInfo = getInfoByPosition(x, y, wheelInfo.value);
  if (!dropInfo || !dropInfo.choose) {
    hiddenDropItem();
    return;
  }
  // 已经填了一个答案上去了, 将这个答案放到下面来
  if (dropInfo.color !== null) {
    checkInfo.value.push({
      serial: dropInfo.old_serial || null,
      color: dropInfo.color,
    });
  }

  // 更新信息
  const newInfo = {
    serial: dropInfo.serial,
    color: dropItem.info?.color || null,
    old_serial:
      dropItem.info?.color === null ? undefined : dropItem.info.serial,
  };
  updateWheelInfo(newInfo);
  // 去掉现在这个
  checkInfo.value = [
    ...checkInfo.value.filter((item) => item.color !== dropInfo.color),
  ];
  hiddenDropItem();
};

// 获取答案
const getAnswer = () => {
  const answerList: { box_serial: any; item_serial: any; color: any }[] = [];
  wheelInfo.value.forEach((i) => {
    if (i.choose && i.color !== null) {
      const answer = {
        box_serial: i.serial,
        item_serial: i.old_serial,
        color: i.color,
      };
      answerList.push(answer);
    }
  });
  // 校验是否碰过答案
  const oldAnswerMap = new Map();
  (props.question?.answer_params?.items || []).forEach((ans: any) =>
    oldAnswerMap.set(ans.box_serial, ans)
  );
  let hasChange = true;
  let hasNew = false;
  for (let i = 0; i < answerList.length; i++) {
    const newAns = answerList[i];
    const oldAns = oldAnswerMap.get(newAns.box_serial);
    // 新做的答案
    if (oldAns === undefined) {
      hasChange = true;
      hasNew = true;
      break;
    }
    // 替换过的答案
    if (
      oldAns.color !== newAns.color ||
      oldAns.item_serial !== newAns.item_serial
    ) {
      hasChange = true;
      hasNew = true;
      break;
    }
    oldAnswerMap.delete(oldAns.box_serial);
  }
  if (oldAnswerMap.size === 0 && hasNew === false) {
    hasChange = false;
  } else {
    hasChange = true;
  }

  if (hasChange === false) {
    return {
      type: 0,
    };
  }
  if (answerList.length > 0) {
    return {
      type: 1,
      answer_params: { items: answerList },
    };
  } else if (answerList.length === 0) {
    return { type: 1, answer_params: undefined };
  }
};

// 交换色环中的色块
const exchangeWheelPiece = (info: any, exchangeInfo: any) => {
  const exInfo = _.cloneDeep(exchangeInfo);
  wheelInfo.value.forEach((p) => {
    if (p.serial === info.serial) {
      p.color = exInfo.color;
      p.old_serial = exInfo.old_serial;
    } else if (p.serial === exInfo.serial) {
      p.color = info.color;
      p.old_serial = info.old_serial;
    }
  });
  wheelCardChart.value.changeData(
    wheelInfo.value.map((i) => ({ ...i, value: 1 }))
  );
};

const getXAndYByClientInfo = (clientX: number, clientY: number) => {
  const left = wheelCardRef.value.getBoundingClientRect().left;
  const top = wheelCardRef.value.getBoundingClientRect().top;
  return {
    x: clientX - left - wheelRadius,
    y: wheelRadius - clientY + top,
  };
};

/** 事件处理部分 */
// 色环点击事件
const handleWheelPieceStartDrag = (e: any) => {
  const x = e.offsetX - wheelRadius;
  const y = wheelRadius - e.offsetY;
  const info = getInfoByPosition(x, y, wheelInfo.value);
  if (!info || !info.choose || info.color === null) {
    return;
  }
  saveDragPieceInfo(e, info, "wheel", true);
};

// 移动端点击色环事件
const handleWheelPieceTouchStartDrag = (e: any) => {
  const left = wheelCardRef.value.getBoundingClientRect().left;
  const top = wheelCardRef.value.getBoundingClientRect().top;
  const touches = e.changedTouches;
  if (!touches || touches.length < 1) {
    hiddenDropItem();
    return;
  }
  const event = touches[0];
  handleWheelPieceStartDrag({
    clientX: event.clientX,
    clientY: event.clientY,
    offsetX: event.clientX - left,
    offsetY: event.clientY - top,
  });
};

// PC端操作框的色块拖拽开始
const handleDragPieceStart = (e: any, info: any) => {
  // 拖拽色块开始
  saveDragPieceInfo(e, info, "opt", true);
};

// 移动端操作框的色块开始拖拽
const handleDragPieceTouchStart = (e: any, info: any) => {
  saveDragPieceInfo(e.changedTouches[0], info, "opt", true);
};

// 色块移动
const handlePieceMove = (e: any) => {
  if (dropItem.show) {
    if (e.preventDefault) {
      e.preventDefault();
    }
    updateMousePosition(e);
  }
};

// 移动端色块移动
const handlePieceTouchMove = (e: any) => {
  if (!dropItem.show) {
    return;
  }
  if (e.preventDefault) {
    e.preventDefault();
  }
  const touches = e.changedTouches;
  if (!touches || touches.length < 1) {
    hiddenDropItem();
    return;
  }
  const event = touches[0];
  updateMousePosition(event);
};

// 将色块加入操作框中
const updateOptInfo = (info: any) => {
  const newInfo = {
    serial: info.serial,
    color: null,
    old_serial: info.old_serial,
  };

  updateWheelInfo(newInfo);
  checkInfo.value.push({
    serial: info.old_serial || null,
    color: info.color,
  });
};

// 判断位置是否在当前的操作框上
const isOnOptBody = (x: number, y: number) => {
  const info = optRef.value.getBoundingClientRect();
  const { left: optX, top: optY, width, height } = info;
  if (x > optX && x < optX + width && y > optY && y < optY + height) {
    return true;
  }
  return false;
};

// 拖拽元素结束
const handleEndDrop = (e: any) => {
  if (!dropItem.show) {
    return;
  }
  const from = _.cloneDeep(dropItem.from);

  // 鼠标拖拽及移动端拖拽都在这里处理
  if (from === "wheel") {
    const info = _.cloneDeep(dropItem.info);
    hiddenDropItem();
    const onOpt = isOnOptBody(e.clientX, e.clientY);
    console.log(onOpt);

    // 判断是放到操作框还是放到环本身
    if (onOpt) {
      updateOptInfo(info);
      return;
    }

    const { x, y } = getXAndYByClientInfo(e.clientX, e.clientY);
    // 根据位置，判断是否是环上的色块
    const wheelPieceByPosition = getInfoByPosition(x, y, wheelInfo.value);

    // 是可放的框且不是自己
    if (
      wheelPieceByPosition !== null &&
      wheelPieceByPosition.choose &&
      wheelPieceByPosition.color !== info.color
    ) {
      exchangeWheelPiece(info, wheelPieceByPosition);
    }
  }
  // 鼠标拖拽的不会从这里处理，这里只处理移动端拖拽的
  else if (from === "opt") {
    handleWheelDrop(e);
  }
  hiddenDropItem();
};

// 移动端拖拽结束
const handleTouchEndDrop = (e: any) => {
  if (!dropItem.show) {
    return;
  }

  const touches = e.changedTouches;
  if (!touches || touches.length < 1) {
    hiddenDropItem();
    return;
  }
  let event = touches[0];
  handleEndDrop(event);
};

/** 生命周期处理 */
expose({ getAnswer });

onMounted(() => {
  initQuestion();
  unLock();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.showQuestionNum)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(questionInfo.value.indexInQuestion !== undefined
            ? questionInfo.value.indexInQuestion + "."
            : "") + _toDisplayString(questionInfo.value.titleNum > 0 ? questionInfo.value.titleNum : ""), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        id: "dvCompile",
        class: "dv-title",
        ref_key: "questionTitle",
        ref: questionTitle
      }, null, 512),
      (__props.showQuestionScore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " (" + _toDisplayString(questionInfo.value.score) + "分) ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "mainBody",
      onMousemove: _cache[2] || (_cache[2] = (e) => !props.disabled && handlePieceMove(e)),
      onMouseup: _cache[3] || (_cache[3] = (e) => !props.disabled && handleEndDrop(e)),
      onTouchmove: _cache[4] || (_cache[4] = (e) => !props.disabled && handlePieceTouchMove(e)),
      onTouchend: _cache[5] || (_cache[5] = (e) => !props.disabled && handleTouchEndDrop(e))
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          id: "wheel_card",
          ref_key: "wheelCardRef",
          ref: wheelCardRef,
          onMousedown: _cache[0] || (_cache[0] = (e) => !props.disabled && handleWheelPieceStartDrag(e)),
          onTouchstart: _cache[1] || (_cache[1] = 
            (e) => !props.disabled && handleWheelPieceTouchStartDrag(e)
          )
        }, null, 544)
      ]),
      _createElementVNode("div", {
        class: "opt_card_body",
        id: "opt_card",
        ref_key: "optRef",
        ref: optRef
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkInfo.value, (checkItem) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${checkItem.serial}-${checkItem.color}`
          }, [
            _createVNode(ColorWheelPiece, {
              onTouchstart: 
              (e) => !props.disabled && handleDragPieceTouchStart(e, checkItem)
            ,
              onMousedown: 
              (e) => !props.disabled && handleDragPieceStart(e, checkItem)
            ,
              serial: checkItem.serial,
              color: checkItem.color
            }, null, 8, ["onTouchstart", "onMousedown", "serial", "color"])
          ]))
        }), 128))
      ], 512),
      (_unref(dropItem).show)
        ? (_openBlock(), _createBlock(ColorWheelPiece, {
            key: 0,
            id: "drop-item",
            class: "move_body",
            serial: _unref(dropItem).info.serial,
            color: _unref(dropItem).info.color || undefined,
            style: _normalizeStyle(_unref(dropItem).style)
          }, null, 8, ["serial", "color", "style"]))
        : _createCommentVNode("", true)
    ], 32),
    (props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(ColorWheelAnswer, {
              list: standardAnswer.value,
              start: startItem.value
            }, null, 8, ["list", "start"])
          ]),
          (props.disabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", {
                  class: "m-analysis-content",
                  innerHTML: props?.question?.analysis || ''
                }, null, 8, _hoisted_11)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})